import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

import orangeMagnetPath from '../images/orange-magnet.png';
import magnetFriendsPath from '../images/magnet-friends.png';
import OrganizationsSearchForm from './forms/OrganizationsSearchForm';
import { useMediumMediaQuery } from "../hooks/responsiveMediaQueries";
import '../css/Home.css'

function Home() {
  const isMedium = useMediumMediaQuery();

  return(
    <>
      <Row className="g-0 home-container">
        <Col md={{ span: 7, order: 1 }} xs={{ span: 12, order: 2 }} className={"d-flex vh-40-container vh-94-md-container vh-40-container align-items-center justify-content-center " + (isMedium ? "home-background-no-magnet" : "home-background-left-magnet")}>
          <Row >
            <Col lg={7} md={10} sm={12} className="pt-md-4 ms-md-4 text-center text-md-start">
              <h1 className="display-4 pb-4 fw-bold"><span className="primary-mw-text">Word of mouth hiring</span> <span className="tertiary-mw-text">meets local economies.</span></h1>
            </Col>
            <Col md={7} sm={12} className="ms-md-4 text-center text-md-start">
              <p className="lead fw-bold">Automated referral tracking, a local rewards marketplace, and a better way to hire with community. <br /><Link to='/employers'>Employers - learn more</Link></p>
            </Col>
            <Col className="d-flex flex-column ms-md-4 ms-lg-0 align-items-center align-items-md-start">
              <img alt="magnetworks" className="orange-magnet-img" src={orangeMagnetPath} />
            </Col>
          </Row>
        </Col>

        <Col md={{ span: 5, order: 2 }}  xs={{ span: 12, order: 1 }} className="d-flex flex-column vh-40-container vh-94-md-container right-half-abstract-magnet dark-background align-items-center justify-content-evenly">
          <Row className="mb-auto"></Row>
          <Row className="gx-0 w-100 mb-auto">
            <OrganizationsSearchForm />
          </Row>
          <Row className="d-flex justify-content-center align-items-center mt-auto text-center text-xl-start">
            <Col xs={12} sm="auto">
              <img alt="magnet-friends" className="magnet-friends-img" src={magnetFriendsPath} />
            </Col>
            <Col xs="auto" className="gx-1">
              <Link className="light-link" to="#" onClick={() => window.open('https://magnetworks-orgs.crd.co/', '_blank')}>
                <Row className="gx-2 align-items-center">
                  <Col xs="auto"><span className="launch-job-feed-text">We love Chambers and Associations: <br/>launch a job feed for your members.</span></Col>
                  <Col><i className="mx-1 fa-solid fa-arrow-up-right-from-square"></i></Col>
                </Row>
              </Link>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}

export default Home;